module.exports = __webpack_public_path__ + "img/zhineng .12183b5b.png";